import { ReactChild, ReactChildren, useState } from "react";
import Text, { TextType } from "components/Text";
import styled from "styled-components";
import {
  BrandColorPalette,
  PrimaryColorPalette,
  TextAndShapesPalette,
} from "lib/styles/colors";
import ExpandAccordianIcon from "lib/svgs/ExpandAccordianIcon";

interface StyleProps {
  isExpanded: boolean;
}

const Container = styled.div<StyleProps>`
  display: flex;
  flex-direction: column;
  padding: 24px;
  border-radius: 8px;
  border-width: 1px;
  ${({ isExpanded }) => `
    border-color: ${
  isExpanded ? BrandColorPalette.BRANDING : TextAndShapesPalette.PLACEHOLDER
};
  `}
`;

const ContentContainer = styled.div<StyleProps>`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  ${({ isExpanded }) =>
    isExpanded &&
    `
    padding-bottom: 24px;
  `}
`;

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

interface Props {
  isOpen: boolean;
  header: string;
  count: number;
  children: ReactChild | ReactChildren;
}

// this probably takes isOpen ,and generic child
export default function InnerAccordianSection({
  isOpen,
  header,
  count,
  children,
}: Props): JSX.Element {
  const [isExpanded, setIsExpaned] = useState<boolean>(isOpen ?? false);

  const toggleOpenState = () => {
    setIsExpaned(!isExpanded);
  };

  return (
    <Container isExpanded={isExpanded}>
      <ContentContainer isExpanded={isExpanded}>
        <HeaderRow onClick={toggleOpenState}>
          <ExpandAccordianIcon
            color={PrimaryColorPalette.MAIN_0}
            rotation={isExpanded ? 90 : 0}
          />
          <Text style={{ marginLeft: "6px" }} type={TextType.TITLE_1}>
            {header}
          </Text>
          <Text
            style={{ marginLeft: "4px" }}
            type={TextType.PARAGRAPH}
            fontColor={TextAndShapesPalette.INPUT_FIELD}
          >
            {`(${count ?? 0} Items)`}
          </Text>
        </HeaderRow>
      </ContentContainer>
      {isExpanded && <>{children}</>}
    </Container>
  );
}
